export const GOOGLE_TRANSLATE_COOKIE = "googtrans";
export const GOOGLE_TRANSLATE_SCRIPT_ID = "google-translate-script";
export const LANGUAGE_PROMPT_KEY = "languagePromptHandled";
export const DEFAULT_LANGUAGE = "pl";
export const AUTOMATIC_TRANSLATION_NOTICE =
  "Tłumaczenie jest generowane automatycznie i może zawierać niedokładności.";
export const LANGUAGE_OPTIONS = [
  {
    value: "pl",
    labels: {
      pl: "Polski",
      en: "Polish",
      de: "Polnisch",
      no: "Polsk",
    },
  },
  {
    value: "en",
    labels: {
      pl: "Angielski",
      en: "English",
      de: "Englisch",
      no: "Engelsk",
    },
  },
  {
    value: "de",
    labels: {
      pl: "Niemiecki",
      en: "German",
      de: "Deutsch",
      no: "Tysk",
    },
  },
  {
    value: "no",
    labels: {
      pl: "Norweski",
      en: "Norwegian",
      de: "Norwegisch",
      no: "Norsk",
    },
  },
  {
    value: "sv",
    labels: {
      pl: "Szwedzki",
      en: "Swedish",
      de: "Schwedisch",
      no: "Svensk",
      sv: "Svenska",
    },
  },
];

export const setGoogleTranslateCookie = (language) => {
  const cookieValue =
    language === DEFAULT_LANGUAGE ? "/auto/pl" : `/auto/${language}`;

  document.cookie = `${GOOGLE_TRANSLATE_COOKIE}=${cookieValue};path=/;max-age=31536000`;
};

export const readGoogleTranslateCookie = () => {
  const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
  const translationCookie = cookies.find((cookie) =>
    cookie.startsWith(`${GOOGLE_TRANSLATE_COOKIE}=`),
  );

  if (!translationCookie) {
    return DEFAULT_LANGUAGE;
  }

  const [, rawValue = ""] = translationCookie.split("=");
  const segments = rawValue.split("/");
  const language = segments[segments.length - 1];

  return language || DEFAULT_LANGUAGE;
};

export const getPreferredLanguage = () => {
  if (typeof navigator === "undefined") {
    return DEFAULT_LANGUAGE;
  }

  const browserLanguage = (navigator.language || navigator.userLanguage || "")
    .toLowerCase()
    .split("-")[0];

  const supportedLanguage = LANGUAGE_OPTIONS.find(
    ({ value }) => value === browserLanguage,
  );

  return supportedLanguage ? supportedLanguage.value : "en";
};

export const getLanguageLabel = (option, locale = DEFAULT_LANGUAGE) => {
  return option.labels[locale] || option.labels.en;
};

export const hasHandledLanguagePrompt = () =>
  window.localStorage.getItem(LANGUAGE_PROMPT_KEY) === "true";

export const markLanguagePromptHandled = () => {
  window.localStorage.setItem(LANGUAGE_PROMPT_KEY, "true");
};

export const ensureGoogleTranslateScript = (onReady) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  window.googleTranslateElementInit = () => {
    if (!window.google?.translate?.TranslateElement) {
      return;
    }

    const container = document.getElementById("google_translate_element");

    if (container && container.childNodes.length === 0) {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: DEFAULT_LANGUAGE,
          includedLanguages: LANGUAGE_OPTIONS.map(({ value }) => value).join(","),
          autoDisplay: false,
        },
        "google_translate_element",
      );
    }

    if (typeof onReady === "function") {
      onReady();
    }
  };

  if (!document.getElementById(GOOGLE_TRANSLATE_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = GOOGLE_TRANSLATE_SCRIPT_ID;
    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);
  } else if (typeof window.googleTranslateElementInit === "function") {
    window.googleTranslateElementInit();
  }
};
